import {createLazyFileRoute} from '@tanstack/react-router'

import Cart from '@/views/Cart/Cart'

export const Route = createLazyFileRoute('/_shop/cart/')({
  component: Cart,
})
